export async function getGoogleAnalysis(ink, width, height) {
  const response = await fetch('https://inputtools.google.com/request?ime=handwriting&app=autodraw&dbg=1&cs=1&oe=UTF-8', {
    method: 'POST',
    body: JSON.stringify({
      input_type: 0,
      requests: [{
        language: 'autodraw',
        writing_guide: {
          width,
          height
        },
        ink
      }]
    }),
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  });
  const _data = await response.json();
  return _data && _data[1] && _data[1][0] && _data[1][0][1] || [];
}